import './RadioButton.less';

import React, { FC } from 'react';
import BlueRadio from 'nike-ui/src/icons/svg/blue-radio-sv.svg';
import clsx from 'clsx';
import FakeCheckInput from '@/nikeone/components/FakeCheckInput';

interface RadioButtonProps extends Record<string, any> {
    active?: boolean;
    className?: string;
    onClick: React.MouseEventHandler;
}
const RadioButton: FC<RadioButtonProps> = ({ active, className, onClick, children, ...other }) => (
    <div className={clsx('radio-button', className, { active })} onClick={onClick ? onClick : null} {...other}>
        <div className={'radio-button-label'}>{children}</div>
        <BlueRadio />
    </div>
);

export function NikeFormRadioButton({ active, className, onClick, children }) {
    return (
        <div className={clsx('radio-button nike-form-radio', className, { active })} onClick={onClick ? onClick : null}>
            <BlueRadio />
            {children}
        </div>
    );
}
export const CheckButton = ({ active, className, onClick, children, dataAtid }) => (
    <div className={clsx('check-button', className, { active })} onClick={onClick} data-atid={dataAtid}>
        <span className="check-button-label">{children}</span>
        <FakeCheckInput checked={active} className="blue" />
    </div>
);

export const NikeFormCheckButton = ({ active, className, onClick, children, ...rest }) => (
    <div className={clsx('check-button nike-form-checkbox', className, { active })} onClick={onClick} {...rest}>
        <FakeCheckInput checked={active} className="nike-form-checkbox-icon blue" />
        {children}
    </div>
);

export default RadioButton;
